(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8769],{

/***/ 25048:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notifications",
      function () {
        return __webpack_require__(73842);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Link */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  &,\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Link = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a.attrs */ .ZP.a.attrs({
    target: "_blank",
    rel: "noreferrer"
})(_templateObject(), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
Link.propTypes = {
    href: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired)
};
/* harmony default export */ __webpack_exports__["Z"] = (Link);


/***/ }),

/***/ 73842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/notifications/layout/layout.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-top: 2rem;\n  margin-bottom: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* responsive */.jW());
var Main = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1());

// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/notifications/layout/menu/menu.styled.ts
function menu_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_styled_templateObject() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  background: ",
        ";\n  list-style: none;\n  border: 1px solid ",
        ";\n"
    ]);
    menu_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_styled_templateObject1() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n      cursor: default;\n      border-left: 3px solid ",
        ";\n      background: ",
        " !important;\n    "
    ]);
    menu_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n      padding-left: 2rem;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  justify-content: space-between;\n  padding: 0 1rem;\n  cursor: pointer;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var menu_styled_Container = styled_components_browser_esm/* default.ul */.ZP.ul(menu_styled_templateObject(), mixins/* reset */.mc(), mixins/* typography */.cp("p2"), colors.M1, colors.T2);
var Item = styled_components_browser_esm/* default.li */.ZP.li(_templateObject3(), mixins/* flexVerticalCenter */.VL(), mixins/* verticalLineMiddle */.XK("2.5rem"), colors.T2, colors.M2, function(props) {
    return props.isActive && (0,styled_components_browser_esm/* css */.iv)(menu_styled_templateObject1(), colors.B1, colors.M1);
}, function(props) {
    return props.indent && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
});

;// CONCATENATED MODULE: ./src/pages/notifications/layout/menu/Menu.component.tsx



var AsktugNotificationType;
(function(AsktugNotificationType) {
    AsktugNotificationType[AsktugNotificationType["replied"] = 2] = "replied";
    AsktugNotificationType[AsktugNotificationType["edited"] = 4] = "edited";
    AsktugNotificationType[AsktugNotificationType["liked"] = 5] = "liked";
    AsktugNotificationType[AsktugNotificationType["liked_grouped"] = 19] = "liked_grouped";
})(AsktugNotificationType || (AsktugNotificationType = {}));
var BlogNotificationType;
(function(BlogNotificationType) {
    BlogNotificationType["POST"] = "POST";
    BlogNotificationType["COMMENT"] = "COMMENT";
    BlogNotificationType["LIKE"] = "LIKE";
    BlogNotificationType["FAVORITE"] = "FAVORITE";
})(BlogNotificationType || (BlogNotificationType = {}));
var SubPage;
(function(SubPage) {
    SubPage["ASKTUG_NOTIFICATION"] = "from=asktug";
    SubPage["ASKTUG_NOTIFICATION_REPLIED"] = "from=asktug&type=2";
    SubPage["ASKTUG_NOTIFICATION_LIKED"] = "from=asktug&type=5,19";
    SubPage["ASKTUG_NOTIFICATION_EDIT"] = "from=asktug&type=4";
    SubPage["BLOG_NOTIFICATION"] = "from=blog";
    SubPage["BLOG_NOTIFICATION_COMMENT"] = "from=blog&type=COMMENT";
    SubPage["BLOG_NOTIFICATION_LIKE"] = "from=blog&type=LIKE";
    SubPage["BLOG_NOTIFICATION_FAVORITE"] = "from=blog&type=FAVORITE";
})(SubPage || (SubPage = {}));
var filterKey = function(filter) {
    return "".concat(filter.from, "|").concat(filter.type);
};
var Menu = function(param) {
    var filter1 = param.filter, onFilterChange = param.onFilterChange, _initIdx = param.initIdx, initIdx = _initIdx === void 0 ? 0 : _initIdx;
    (0,react.useEffect)(function() {
        if (!filter1) {
            click(list[initIdx].filter)();
        }
    }, [
        filter1,
        initIdx
    ]);
    (0,react.useEffect)(function() {
        if (!filter1) {
            onFilterChange(list[initIdx].filter);
        }
    }, [
        filter1,
        onFilterChange,
        initIdx
    ]);
    var click = function(filter) {
        return function() {
            onFilterChange(filter);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_styled_Container, {
        children: list.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                indent: item.indent,
                isActive: filter1 === item.filter,
                onClick: click(item.filter),
                children: item.title
            }, filterKey(item.filter));
        })
    });
};
var list = [
    {
        filter: {
            from: "asktug",
            type: undefined
        },
        title: "\u8BBA\u575B\u6D88\u606F",
        indent: false
    },
    {
        filter: {
            from: "asktug",
            type: AsktugNotificationType.replied
        },
        title: "\u56DE\u590D\u6211\u7684",
        indent: true
    },
    {
        filter: {
            from: "asktug",
            type: [
                AsktugNotificationType.liked,
                AsktugNotificationType.liked_grouped
            ]
        },
        title: "\u83B7\u5F97\u8D5E",
        indent: true
    },
    {
        filter: {
            from: "asktug",
            type: AsktugNotificationType.edited
        },
        title: "\u7F16\u8F91",
        indent: true
    },
    {
        filter: {
            from: "blog"
        },
        title: "\u4E13\u680F\u6D88\u606F",
        indent: false
    },
    {
        filter: {
            from: "blog",
            type: BlogNotificationType.COMMENT
        },
        title: "\u8BC4\u8BBA\u6211\u7684",
        indent: true
    },
    {
        filter: {
            from: "blog",
            type: BlogNotificationType.LIKE
        },
        title: "\u83B7\u5F97\u8D5E",
        indent: true
    },
    {
        filter: {
            from: "blog",
            type: BlogNotificationType.FAVORITE
        },
        title: "\u6536\u85CF\u6211\u7684",
        indent: true
    },
    {
        filter: {
            from: "blog",
            type: BlogNotificationType.POST
        },
        title: "\u7CFB\u7EDF\u901A\u77E5",
        indent: true
    }, 
];
/* harmony default export */ var Menu_component = (Menu);

;// CONCATENATED MODULE: ./src/pages/notifications/layout/menu/index.ts


// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
;// CONCATENATED MODULE: ./src/pages/notifications/layout/Layout.component.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var Layout = function(_param) {
    var children = _param.children, menuProps = _objectWithoutProperties(_param, [
        "children"
    ]);
    var setIsAuthRequired = (0,react.useContext)(context/* AuthContext */.Vo).setIsAuthRequired;
    (0,react.useEffect)(function() {
        setIsAuthRequired(true);
        return function() {
            return setIsAuthRequired(false);
        };
    }, [
        setIsAuthRequired
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* SiteLayout */.I, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                    title: "\u6D88\u606F\u4E2D\u5FC3"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        gutter: [
                            32,
                            32
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                sm: 8,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_component, _objectSpread({}, menuProps))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                sm: 16,
                                md: 18,
                                style: {
                                    height: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                                    children: children
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Layout_component = (Layout);

;// CONCATENATED MODULE: ./src/pages/notifications/layout/index.ts


// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/swr/infinite/dist/index.mjs
var dist = __webpack_require__(44593);
// EXTERNAL MODULE: ./src/api/index.ts + 2 modules
var api = __webpack_require__(89590);
// EXTERNAL MODULE: ./node_modules/@pingcap-inc/tidb-community-site-components/dist/index.js + 36 modules
var tidb_community_site_components_dist = __webpack_require__(47569);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
// EXTERNAL MODULE: ./node_modules/antd/es/list/index.js + 1 modules
var es_list = __webpack_require__(95507);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/index.js + 1 modules
var config_provider = __webpack_require__(19040);
// EXTERNAL MODULE: ./src/pages/private-messages/PrivateMessages.component.tsx
var PrivateMessages_component = __webpack_require__(53848);
;// CONCATENATED MODULE: ./src/pages/notifications/Asktug.component.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Asktug_component_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function Asktug_component_templateObject() {
    var data = Asktug_component_taggedTemplateLiteral([
        "\n  .ant-list-empty-text {\n    padding: 0;\n  }\n"
    ]);
    Asktug_component_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ListLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            //  center the child
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {})
    });
};
var List = (0,styled_components_browser_esm/* default */.ZP)(es_list/* default */.ZP)(Asktug_component_templateObject());
var Asktug = function(param) {
    var filter = param.filter;
    var ref2 = (0,dist/* default */.ZP)(function(n) {
        return [
            "asktug.getNotifications",
            {
                offset: n * 60,
                type: filter.type
            }
        ];
    }, {
        fetcher: api/* fetcher */._i
    }), data = ref2.data, mutate = ref2.mutate, size1 = ref2.size, setSize = ref2.setSize, isValidating = ref2.isValidating;
    var ref1 = (0,react.useState)([]), notifications1 = ref1[0], setNotifications = ref1[1];
    (0,react.useEffect)(function() {
        setNotifications([]);
        mutate(function() {
            return undefined;
        }, false).then();
        setSize(1).then();
    }, [
        filter,
        mutate,
        setNotifications,
        setSize
    ]);
    (0,react.useEffect)(function() {
        if (!isValidating) {
            if (data) {
                setNotifications(data.flatMap(function(notifications) {
                    return notifications.notifications;
                }));
            } else {
                setNotifications([]);
            }
        }
    }, [
        data,
        size1,
        isValidating
    ]);
    var hasMore = (0,react.useMemo)(function() {
        var ref;
        if (isValidating) {
            return true;
        }
        if (!data) {
            return false;
        }
        if (size1 === 0) {
            return true;
        }
        return ((ref = data[size1 - 1]) === null || ref === void 0 ? void 0 : ref.notifications.length) > 0;
    }, [
        data,
        size1,
        isValidating
    ]);
    var loadMoreData = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return setSize(function(size) {
                        return size + 1;
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        setSize
    ]);
    var markRead = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(id) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        api/* api.asktug.readNotification */.hi.asktug.readNotification(id).catch(console.error);
                        mutate(function(notifications) {
                            var changed = false;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = notifications[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var bulk = _step.value;
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = bulk.notifications[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var notification = _step1.value;
                                            if (notification.id === id && !notification.read) {
                                                notification.read = true;
                                                changed = true;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            if (changed) {
                                return _toConsumableArray(notifications);
                            } else {
                                return notifications;
                            }
                        }, false).catch(console.error);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "scrollableDiv",
        style: {
            height: 600,
            overflow: "auto",
            padding: "0 16px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
            dataLength: notifications1.length,
            next: loadMoreData,
            hasMore: hasMore,
            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLoader, {}),
            scrollableTarget: "scrollableDiv",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(config_provider/* default */.ZP, {
                renderEmpty: function() {
                    return !isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateMessages_component/* ListPlaceholder */.a, {
                        text: "\u6682\u65F6\u8FD8\u6CA1\u6709\u6D88\u606F"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    dataSource: notifications1,
                    renderItem: function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tidb_community_site_components_dist/* DiscourseNotification */.sy, {
                            notification: item,
                            wrap: function(el) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(List.Item, {
                                    children: el
                                });
                            },
                            markRead: markRead
                        }, item.id);
                    }
                })
            })
        })
    });
};
/* harmony default export */ var Asktug_component = (Asktug);

;// CONCATENATED MODULE: ./src/pages/notifications/Blog.component.tsx
function Blog_component_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Blog_component_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Blog_component_arrayLikeToArray(arr);
}
function Blog_component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Blog_component_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Blog_component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Blog_component_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function Blog_component_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Blog_component_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Blog_component_toConsumableArray(arr) {
    return Blog_component_arrayWithoutHoles(arr) || Blog_component_iterableToArray(arr) || Blog_component_unsupportedIterableToArray(arr) || Blog_component_nonIterableSpread();
}
function Blog_component_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Blog_component_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Blog_component_arrayLikeToArray(o, minLen);
}











var Blog = function(param) {
    var filter = param.filter;
    var ref = (0,dist/* default */.ZP)(function(n) {
        return [
            "blog.getNotifications",
            {
                page: n + 1,
                type: filter.type
            }
        ];
    }, {
        fetcher: api/* fetcher */._i,
        dedupingInterval: 100
    }), data = ref.data, mutate = ref.mutate, size1 = ref.size, setSize = ref.setSize, isValidating = ref.isValidating;
    console.log(data);
    var ref1 = (0,react.useState)([]), notifications1 = ref1[0], setNotifications = ref1[1];
    (0,react.useEffect)(function() {
        setNotifications([]);
        mutate(function() {
            return undefined;
        }, false).then();
        setSize(1).then();
    }, [
        filter,
        mutate,
        setNotifications,
        setSize
    ]);
    (0,react.useEffect)(function() {
        if (!isValidating) {
            if (data) {
                setNotifications(data.flatMap(function(notifications) {
                    return notifications.content;
                }));
            } else {
                setNotifications([]);
            }
        }
    }, [
        data,
        size1,
        isValidating
    ]);
    var hasMore = (0,react.useMemo)(function() {
        if (isValidating) {
            return true;
        }
        if (!data) {
            return false;
        }
        if (size1 === 0) {
            return true;
        }
        console.log(data);
        var lastPage = data[data.length - 1];
        return lastPage.page.number < lastPage.page.totalPages;
    }, [
        data,
        size1,
        isValidating
    ]);
    var loadMoreData = (0,react.useCallback)(Blog_component_asyncToGenerator(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return setSize(function(size) {
                        return size + 1;
                    });
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        setSize
    ]);
    var markRead = (0,react.useCallback)(function() {
        var _ref = Blog_component_asyncToGenerator(runtime_default().mark(function _callee(id) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        api/* api.blog.readNotification */.hi.blog.readNotification(id).catch(console.error);
                        mutate(function(notifications) {
                            var changed = false;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = notifications[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var bulk = _step.value;
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = bulk.content[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var notification = _step1.value;
                                            if (notification.id === id && !notification.haveRead) {
                                                notification.haveRead = true;
                                                changed = true;
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            if (changed) {
                                return Blog_component_toConsumableArray(notifications);
                            } else {
                                return notifications;
                            }
                        }, false).catch(console.error);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }(), [
        mutate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "scrollableDiv",
        style: {
            height: 600,
            overflow: "auto",
            padding: "0 16px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
            dataLength: notifications1.length,
            next: loadMoreData,
            hasMore: hasMore,
            loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListLoader, {}),
            scrollableTarget: "scrollableDiv",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(config_provider/* default */.ZP, {
                renderEmpty: function() {
                    return !isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateMessages_component/* ListPlaceholder */.a, {
                        text: "\u6682\u65F6\u8FD8\u6CA1\u6709\u6D88\u606F"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    dataSource: notifications1,
                    renderItem: function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tidb_community_site_components_dist/* BlogNotification */.RW, {
                            notification: item,
                            wrap: function(el) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(List.Item, {
                                    children: el
                                });
                            },
                            markRead: markRead
                        }, item.id);
                    }
                })
            })
        })
    });
};
/* harmony default export */ var Blog_component = (Blog);

;// CONCATENATED MODULE: ./src/pages/notifications/index.page.tsx






var Page = function(param) {
    var initIdx = param.initIdx;
    var ref = (0,react.useState)(), filter = ref[0], setFilter = ref[1];
    var titleSuffix = (0,react.useMemo)(function() {
        switch(filter === null || filter === void 0 ? void 0 : filter.from){
            case "asktug":
                return "AskTUG";
            case "blog":
                return "\u4E13\u680F";
            default:
                return undefined;
        }
    }, [
        filter === null || filter === void 0 ? void 0 : filter.from
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: titleSuffix == null ? "\u901A\u77E5" : "\u901A\u77E5 - ".concat(titleSuffix)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout_component, {
                filter: filter,
                onFilterChange: setFilter,
                initIdx: initIdx,
                children: [
                    (filter === null || filter === void 0 ? void 0 : filter.from) === "asktug" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Asktug_component, {
                        filter: filter
                    }) : undefined,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    (filter === null || filter === void 0 ? void 0 : filter.from) === "blog" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog_component, {
                        filter: filter
                    }) : undefined
                ]
            })
        ]
    });
};
/* harmony default export */ var index_page = (Page);


/***/ }),

/***/ 53848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ ListPlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95507);
/* harmony import */ var _tidb_community_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33358);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _pingcap_inc_tidb_community_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68664);
/* harmony import */ var _api_asktug__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93236);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59914);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  // center a placeholder image\n  background-image: url('",
        "');\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 120px;\n  //margin-top: 4rem;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_tidb_community_ui__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject());
var PlaceHolder = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div */ .ZP.div(_templateObject1(), _utils__WEBPACK_IMPORTED_MODULE_3__/* .cdn.getImageUrl */ .cK.getImageUrl("/images/list-placeholder.svg"));
function ListPlaceholder(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            fontSize: 14,
            textAlign: "center",
            width: "100%",
            height: 600,
            background: "#F7F8F9",
            borderRadius: 6,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlaceHolder, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        fontSize: 16,
                        color: _pingcap_inc_tidb_community_ui__WEBPACK_IMPORTED_MODULE_1__/* .colors.F2 */ .O9.F2,
                        marginTop: "1rem"
                    },
                    children: text
                })
            ]
        })
    });
}
var PrivateMessages = function(param) {
    var messages = param.messages;
    if (!messages || messages.length === 0) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListPlaceholder, {
        text: "\u8FD8\u6CA1\u6709\u79C1\u4FE1\u54E6"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
        pagination: {
            onChange: function(page) {
                console.log(page);
            },
            pageSize: 10
        },
        dataSource: messages,
        renderItem: function(item) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Item */ .ZP.Item, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Item.Meta */ .ZP.Item.Meta, {
                        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Link, {
                            href: "".concat(_api_asktug__WEBPACK_IMPORTED_MODULE_2__.askTugDomain, "/t/topic/").concat(item.id),
                            children: item.fancy_title
                        }),
                        description: item.users.reduce(function(acc, user) {
                            return acc + user.username + " ";
                        }, "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            color: "#8C8C8C"
                        },
                        children: new Date(item.last_posted_at).toLocaleDateString("zh-Hans-CN")
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrivateMessages);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3202,9774,2888,179], function() { return __webpack_exec__(25048); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);